import { useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import { Row, Col } from 'antd'
import systemActions from '../../redux/systemInfos/actions';
import { DvIntlMessages } from "../../components/utility/dvGeneralUtilities";
import Box from '../../components/utility/box';

const { getGeneralInfos } = systemActions;

function GeneralInfos(props) {
  useEffect(() => {
    props.getGeneralInfos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Box>
      <Row gutter={[64, 16]}>
        {props.generalInfos.numberOfClinics && <Col>
          {`${DvIntlMessages('general.clinics')}: ${props.generalInfos.numberOfClinics}`}
        </Col>}

        {props.generalInfos.numberOfUsers && <Col>
          {`${DvIntlMessages('general.users')}: ${props.generalInfos.numberOfUsers}`}
        </Col>}

        {props.generalInfos.numberOfPatients && <Col>
          {`${DvIntlMessages('general.patients')}: ${props.generalInfos.numberOfPatients}`}
        </Col>}

        {props.generalInfos.totalFileSize && <Col>
          {`${DvIntlMessages('homePage.generalInfos.totalFileSize')}: ${props.generalInfos.totalFileSize} GB`}
        </Col>}

        {props.generalInfos.uploadsDirectorySize && <Col>
          {`${DvIntlMessages('homePage.generalInfos.uploadedDirectorySize')}: ${props.generalInfos.uploadsDirectorySize}`}
        </Col>}

        {props.generalInfos.temporaryDirectorySize && <Col>
          {`${DvIntlMessages('homePage.generalInfos.temporaryDirectorySize')}: ${props.generalInfos.temporaryDirectorySize}`}
        </Col>}
      </Row>
    </Box>
  )
}

GeneralInfos.propTypes = {
  generalInfos: PropTypes.shape({
    numberOfClinics: PropTypes.number,
    numberOfUsers: PropTypes.number,
    numberOfPatients: PropTypes.number,
    totalFileSize: PropTypes.string,
    uploadsDirectorySize: PropTypes.string,
    temporaryDirectorySize: PropTypes.string
  }),

  getGeneralInfos: PropTypes.func.isRequired
};

GeneralInfos.defaultProps = {
  generalInfos: {
    'numberOfClinics': null,
    'numberOfUsers': null,
    'numberOfPatients': null,
    'totalFileSize': null,
    'uploadsDirectorySize': null,
    'temporaryDirectorySize': null
  }
}

const mapActionsToProps = {
  getGeneralInfos
};

function mapStateToProps(state) {
  return {
    generalInfos: state.SystemInfos.get('generalInfos')
  };
}

const connectedApp = connect(mapStateToProps, mapActionsToProps)(GeneralInfos);
export default connectedApp;
